export const pad = (value: number, format: string) => {
  const str = String(value);
  return format.substring(0, format.length - str.length) + str;
};

export const getPercentage = (partialValue: number, totalValue: number) => (100 * partialValue) / totalValue;
